// ────────────────────────────────────────────────────────────────────────────
// The Brain Starter: the free, copy-paste prompt in the challenge waitlist's
// confirmation email and on the public page `/challenge/brain-starter`.
//
// One source for both, so the email and the page never drift. It is a small
// sample of Day 4 (Build your Business Brain AI): one interview, one page, no
// voice step and no skill files, so the paid Business Brain Builder stays the
// full version. Copy: docs/work/2026-09-29-sales-waitlist/waitlist-emails.md.
// ────────────────────────────────────────────────────────────────────────────

export const BRAIN_STARTER_PATH = '/challenge/brain-starter';

export const BRAIN_STARTER_PROMPT = `I want you to help me write a one-page note about my business that I can give to any AI, so its answers stop being generic.

Interview me first. Ask one short question at a time and wait for my answer before asking the next. Cover these, in this order:

1. What I do, in a sentence or two. If I don't have a business yet, ask about the idea I'm working on or the work I do now.
2. Who it's for: my best customers, or the people I want to serve, and what's going on for them when they find me.
3. What I sell or plan to sell, and roughly what it costs.
4. How people find me and how they buy.
5. Why people pick me over the other options they have.
6. The questions and objections I hear most.
7. How I sound when I write: a few words that describe it, and any words I never use.
8. What I'm working towards over the next 90 days.
9. The jobs that take up most of my week.

If an answer is thin, ask one follow-up, then move on. Don't give me advice during the interview.

When we're done, write the note and call it "About my business". Keep it to one page, with short headings and bullet points, and use my own words where you can. Don't invent anything I didn't tell you. If something is missing, add a line starting "To add:" so I can fill it in later.

Then suggest one real task from my week that I could try with this note pasted at the top of a new chat, so I can see the difference it makes.

Start with your first question.`;
